import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Peruttu',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Vastaanotettu',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Vahvistettu',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'Valmistetaan',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'Matkalla',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Valmis',
  served: 'Tarjoiltu',
  status: {
    actual: 'Nykyinen',
    pending: 'Odottaa',
  },
  warning_label: {
    pickup_time_changed: '{{company}} muutti ajan ajasta {{initialTime}} aikaan {{currentTime}}',
  },
  labels: {
    order_number: 'Tilausnro: {{number}}',
    today: 'Tänään',
  },
};
